<script setup>
import { onBeforeUnmount, onMounted, ref } from "vue";
import { useRoute, useRouter } from 'vue-router'
import { useActiveDeviceRenderStore } from "@/stores/activeDeviceRender";
import axios from "axios";
import { storeToRefs } from "pinia";
import { useWebsiteStore } from "@/stores/website";
import { useUserStore } from "@/stores/user";
import RadialProgress from "vue3-radial-progress";
import Spinner from "@/components/Spinner.vue";
import { getProgressColor } from "@/utils";
import { observeInlineFaIcons } from '@/utils/inlineFaIcons';

const activeDeviceRender = useActiveDeviceRenderStore();
const router = useRouter()
const route = useRoute()
let fromPath = route.meta.origin
const websiteStore = useWebsiteStore();
const {website} = storeToRefs(websiteStore);
const userStore = useUserStore();
const previewRoot = ref(null)
let stopInlineFaObserver = () => {}

async function recheck() {
  try {
    let r = await axios.post(`websites/${website.value.shortuuid}/add-pages/`, {
      pages: [activeDeviceRender.page.url]
    })
    if (r.data.status === 'success') {
      //userStore.showNotification('Scan recheck initiated')
    } else {
      console.log(r)
    }
  } catch
      (e) {
    if (e.response.status >= 400) {
      if (e.response.data.code === 'subscription') {
        userStore.showNotification('plan')
      } else if (e.response.status === 401) {
        userStore.showNotification('login')
      }
    }
  }

}

onMounted(() => {
      let myModal = new bootstrap.Modal(document.getElementById('modal-block-tabs-altx'), {})
      let myModalEl = document.getElementById('modal-block-tabs-altx')
      myModalEl.addEventListener('hidden.bs.modal', function (event) {
        if (fromPath) {
          let path = route.fullPath;
          path = path.substring(0, path.indexOf('/preview/'))

          if (fromPath.includes(path) && !fromPath.includes('/preview/') && !fromPath.includes('/opportunity/')) {
            router.push(fromPath)
          } else {
            router.push(path)
          }

        }
      })
      myModal.show()
      stopInlineFaObserver = observeInlineFaIcons(previewRoot.value)

    }
)
onBeforeUnmount(() => {
  stopInlineFaObserver()
  let myModalEl = document.getElementById('modal-block-tabs-altx')
  let modal = bootstrap.Modal.getInstance(myModalEl)

  if (myModalEl.classList.contains('show')) {
    fromPath = '';
    modal.hide()
  }
});

const imageRoot = import.meta.env.VITE_IMAGE_ROOT;
const siteLogo = website.value.previewFavicon ? `${imageRoot}${website.value.previewFavicon}?tr=w-20` : "/assets/media/favicons/favicon.png"
</script>

<template>

  <div ref="previewRoot">
    <div
        class="modal load-transition"
        id="modal-block-tabs-altx"
        tabindex="-1"
        role="dialog"
        aria-labelledby="modal-block-tabs-alt"
        aria-hidden="true"
    >
      <div v-show="!activeDeviceRender.loaded" style="position:absolute;top:50%;left:50%">
        <div class="loading-container">

    <span class="spinner-border text-primary ms-2 me-2 text-muted"
          style="font-size:18px;height:28px;width:28px;color:white !important;">      </span>
      </div>
    </div>
    <div v-show="activeDeviceRender.loaded"
         class="modal-dialog load-transition forced-large-modal modal-xl"
         role="document">
      <div id="preview-modal" class="modal-content load-transition " style="background-color:#EBEEF2">
        <div class="block-rounded block-transparent block mb-0">
          <div class="block-header block-header-default " v-if="activeDeviceRender.page">

           <h3 class="block-title text-normal ms-6 me-4"
                style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; max-width: 100%;">

              <img :src="siteLogo" width="20" height="20" class="me-2">
              <a target="_blank" :href="activeDeviceRender.page?.url" v-tooltip="`External link`"
                 class="external-link-plain"
                 style="overflow: hidden; text-overflow: ellipsis; white-space: nowrap; display: inline-block; max-width: 100%; vertical-align: bottom;">{{
                  activeDeviceRender.page?.url
                }}</a>
            </h3>
            <div class="block-options space-x-1" v-if="activeDeviceRender.page">



              <small class="text-muted" v-if="['completed'].includes(activeDeviceRender.page.status)">Last Check: {{
                  $filters.dateRelative(activeDeviceRender.page.crawlDate)
                }}</small>
              <small class="text-muted" v-else-if="['pending', 'in_progress'].includes(activeDeviceRender.page.status)"> <spinner></spinner> Scan In Progress</small>
              <button
                  v-if="activeDeviceRender.page && ['completed', 'error'].includes(activeDeviceRender.page.status) "
                  v-tooltip="`Check Again`" class="btn btn-sm" @click="recheck()"><span
                  class="fa fa-refresh"></span></button>
              <button type="button" class="btn-block-option" data-bs-dismiss="modal" aria-label="Close"><i
                  class="fa fa-fw fa-times"></i></button>
            </div>
          </div>
          <div class="block-content fs-sm p-0">
            <div class="" role="tablist">
            </div>
            <div class="block-content tab-content" style="height:100%;padding:0;margin:0">
              <div
                  class="tab-pane active preview-body"
                  id="btabs-alt-static-home"
                  role="tabpanel"
                  aria-labelledby="btabs-alt-static-home-tab"
                  tabindex="0"
              >
                <router-view></router-view>
              </div>
            </div>
          </div>
        </div>

      </div>
      </div>
    </div>
  </div>

</template>
<style>
@media only screen and (min-width: 1366px) {
  .forced-large-modal {
    max-width: 1200px;
    width: 1200px;
    .col-xl-5{
      width: 44%;
    }
    .col-xl-7{
      width: 55%;
    }
    .container {
      max-width: 1200px;
      padding-left: 4px;
    }
  }
}

@media only screen and (min-width: 768px) {
  .forced-large-modal {
    min-width: 740px
  }
}

@media only screen and (max-width: 1199px) and  (min-width: 768px) {

  .block-content {
    padding-right: 4px;
  }
}

.preview-body {
  .accordion-button {
    background-color: white;
  }

  .accordion-button:not(.collapsed) {
    background-color: #fcfcff; /* color of the track */
    box-shadow: none;

  }

  .accordion-button::after {
    scale: 0.8;
  }

  .accordion-item {
    border: 0;
  }

  .accordion-button:focus {
    outline: none !important;
    box-shadow: none !important;
    border-color: transparent !important;
  }
}
</style>